var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"_comp_skeleton_wrapper"},_vm._l((_setup.skeletons),function(item,index){return _c('div',{key:index,staticClass:"_comp_skeleton",style:([{ width: `${_vm.width}%` }, { height: `${_vm.height}px` }])},[_vm._t("default")],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }